/** The per-template crop records of a scene. */
export const CROP_FIELDS = ["bgX", "bgY", "bgScale", "bgRotate", "bgFlip"] as const;

type Scene = Record<string, any>;

/**
 * A crop describes one image. When a layer gives a banner its own image
 * (`customBgs[id]`), a crop from a LESS specific layer was made for another
 * image — usually the gallery one — and must not move this one. Such crops
 * are dropped from the merged scene; crops saved in the image's own layer,
 * or in a more specific one, stay.
 *
 * `layers` are the merged scenes ordered least → most specific; `merged` is
 * their per-key merge. Returns `merged` itself when nothing changes.
 */
export function cropsFollowImages(layers: Scene[], merged: Scene): Scene {
  const images = merged.customBgs;
  if (!images || typeof images !== "object") return merged;
  let out = merged;
  for (const [id, url] of Object.entries(images)) {
    if (!url || id === "main") continue;
    let from = -1;
    layers.forEach((layer, i) => {
      if (layer?.customBgs?.[id] !== undefined) from = i;
    });
    for (const field of CROP_FIELDS) {
      if (merged[field]?.[id] === undefined) continue;
      let found = false;
      let value: unknown;
      for (let i = from; i < layers.length; i++) {
        const v = layers[i]?.[field]?.[id];
        if (v !== undefined) {
          found = true;
          value = v;
        }
      }
      if (found && value === merged[field][id]) continue;
      if (out === merged) out = {...merged};
      out[field] = {...out[field]};
      if (found) out[field][id] = value;
      else delete out[field][id];
    }
  }
  return out;
}
